"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.validation.nameRequired': '教程名称为必填项',
    'tutorial.validation.sectionsRequired': '至少需要一个部分',
    'tutorial.validation.sectionTitleRequired': '第{index}部分标题为必填项',
    'tutorial.validation.stepsRequired': '至少需要一个步骤',
    'tutorial.validation.stepTitleRequired': '步骤{index}标题为必填项',
    'tutorial.validation.stepSectionsRequired': '步骤{index}必须至少有一个节',
};
